export class MediaInfosSidenavController {
    public static $inject: string[] = [
        "$mdMedia",
        "categoryService",
        "printItemService",
        "utilsService"
    ];

    public field;
    public item;
    public noDealerIcon: string = require("../../../../assets/icons/no-dealer-icon.png");

    constructor(
        public $mdMedia: ng.material.IMedia,
        private categoryService,
        private printItemService,
        public utilsService
    ) {}

    public $onInit() {
        this.field = this.categoryService.getFieldLabel(this.item.category.field);
    }

    public printItem() {
        this.printItemService.print(this.item);
    }
}
